import { FC, ReactNode } from 'react';

import { badgeRecipe } from './Badge.css';
import { getClassNames } from '../../util/css';
import { RecipeVariants } from '../../vanilla-extract.css';

type Props = RecipeVariants<typeof badgeRecipe> & {
  children: ReactNode;
  className?: string;
};

const sparkyBadgeClassName = 'sparky-badge';

export const Badge: FC<Props> = ({ children, color = 'alpha', size = 'S', className = '' }) => {
  const classNames = getClassNames(sparkyBadgeClassName, badgeRecipe({ color, size }), className);
  return <span className={classNames}>{children}</span>;
};

Badge.toString = () => `.${sparkyBadgeClassName}`;
Badge.displayName = 'Badge';
